import { createSlice } from "@reduxjs/toolkit";
import { setInitialState } from "../../../../store/InitialState";

const INITIAL_STATE = setInitialState({
    data: null,
    isFetching: false,
    isSuccess: false,
    isError: false,
    error: null,
});

const requestMFACodeSlice = createSlice({
    name: "requestMFACodeSlice",
    initialState: INITIAL_STATE,
    reducers: {
        requestMFACodeOverEmailRequest: (state) => {
            state.isFetching = true;
        },
        requestMFACodeOverEmailSuccess: (state, action) => {
            state.isFetching = false;
            state.isSuccess = true;
            state.data = action.payload;
        },
        requestMFACodeOverEmailFailure: (state, action) => {
            state.isFetching = false;
            state.isSuccess = false;
            state.isError = true;
            state.error = action.payload;
        },
        resetRequestMFACodeOverEmail: (state) => {
            state.data = null;
            state.error = null;
            state.isError = false;
            state.isFetching = false;
            state.isSuccess = false;
        },
    },
});

// Exporting actions for saga and views
export const {
    requestMFACodeOverEmailRequest,
    requestMFACodeOverEmailSuccess,
    requestMFACodeOverEmailFailure,
    resetRequestMFACodeOverEmail,
} = requestMFACodeSlice.actions;

export default requestMFACodeSlice.reducer;
